const OnScroll = function (settings) {
	"use strict";

	const _self = this;
	const _settings = {
		pageHeaderScroll: 0,
		pageHeaderThreshold: 100,
	};

	Object.assign(_settings, settings);

	function bindEvents() {
		window.addEventListener("scroll", handleScroll);
	}

	function handleScroll() {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if (st <= _settings.pageHeaderThreshold) {
			document.body.classList.remove(_settings.bodyScrollClass);
			return;
		}

		if (!document.body.classList.contains(_settings.bodyScrollClass)) {
			document.body.classList.add(_settings.bodyScrollClass);
		}
	}

	function init() {
		bindEvents();

		return _self;
	}

	return init();
};

export { OnScroll };
